interface ConfigParams {
  API_URL: string;
}

class ConfigService {
  private readonly currentConfig = process.env;
  private readonly windowConfig = (window as { _env_?: ConfigParams })._env_;

  public get<K extends keyof ConfigParams>(paramName: K, defaultValue?: ConfigParams[K]): ConfigParams[K] | undefined {
    return this.windowConfig?.[paramName] ?? this.currentConfig[paramName] ?? defaultValue;
  }
}

export const configService = new ConfigService();
export default configService;
